export default __webpack_public_path__ + "static/media/ic_tunisia.ffedcbe4.svg";